import React from 'react';
import { Flame } from 'lucide-react';

export const StreakBadge = ({ streak }) => {
  if (!streak) return null;

  const streakCount = streak.current_streak || 0;
  const hasActivity = streak.has_activity_today;
  const isActive = streakCount > 0 && hasActivity;
  const label = `${streakCount} day streak${hasActivity ? ' — active today!' : ''}`;

  return (
    <div
      className={`flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2 sm:px-2.5 text-sm font-semibold transition-[color,background-color,box-shadow] duration-300 ${
        isActive
          ? 'bg-gradient-to-r from-orange-500/20 to-amber-500/20 border border-orange-400/40 text-orange-400 shadow-[0_0_12px_rgba(251,146,60,0.3)]'
          : streakCount > 0
            ? 'bg-muted/40 border border-border/50 text-muted-foreground'
            : 'bg-muted/20 text-muted-foreground/60'
      }`}
      data-testid="top-streak-counter"
      title={label}
      aria-label={label}
    >
      <Flame
        size={16}
        aria-hidden="true"
        className={`shrink-0 transition-colors duration-300 ${
          isActive
            ? 'text-orange-400 drop-shadow-[0_0_6px_rgba(251,146,60,0.6)] motion-safe:animate-pulse'
            : streakCount > 0
              ? 'text-orange-400/60'
              : 'text-muted-foreground/40'
        }`}
      />
      <span>{streakCount}</span>
      {isActive && streakCount >= 30 && (
        <span className="text-[10px] ml-0.5 opacity-80">
          {streakCount >= 365 ? '!!!' : streakCount >= 100 ? '!!' : '!'}
        </span>
      )}
    </div>
  );
};